var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommDraft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7513 25.1665C17.5846 25.4998 17.668 25.9165 18.0013 26.0832C18.168 26.2498 18.3346 26.3332 18.5846 26.3332C18.7513 26.3332 18.8346 26.3332 19.0013 26.2498L24.3346 23.1665L20.0013 19.9165L17.7513 25.1665Z",
    fill: "#73007D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5846 21.9999L37.2513 8.16659C37.668 7.66659 37.918 6.99992 37.8346 6.24992C37.668 5.08325 36.168 3.99992 36.168 3.99992C35.168 3.41659 33.918 3.24992 32.668 4.49992L20.918 18.4999L25.5846 21.9999Z",
    fill: "#73007D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.83472 26.3332V4.6665C3.00138 4.6665 1.83472 8.33317 1.83472 9.6665V28.8332C3.16805 26.9165 6.83472 26.3332 6.83472 26.3332Z",
    fill: "#73007D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6681 13.8333H34.5847L26.2514 23.7499C26.0847 23.9999 25.8347 24.1666 25.5847 24.3333L19.7514 27.6666C18.8347 28.1666 17.6681 28.0833 16.8347 27.3333C16.0014 26.5833 15.7514 25.4999 16.1681 24.4999L18.6681 18.6666C18.7514 18.4999 22.6681 13.8333 22.6681 13.8333H8.50138V27.9999H6.83472C4.16805 28.1666 2.00138 30.3333 1.83472 33.0833C1.83472 36.9999 4.25138 38.8333 7.25138 38.8333H37.6681C38.1681 38.8333 38.5014 38.4999 38.5014 37.9999V14.6666C38.5014 14.1666 38.1681 13.8333 37.6681 13.8333Z",
    fill: "#73007D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommDraft);
export default __webpack_public_path__ + "static/media/comm_draft.cfaa609f3670b24d77ac98bd97d0ca4d.svg";
export { ForwardRef as ReactComponent };